"use client";
import React from "react";
import Image from "next/image";
import { MapPin } from "lucide-react";
import highlight from "@/assest/home1.gif";

interface IProps {
  highlights?: { title: string }[];
  imageGallery?: { image: string }[];
}

const PackageHighlights = ({ highlights, imageGallery }: IProps) => {
  const packageHighlights = highlights ?? [];
  const gallery = imageGallery ?? [];
  const [active, setActive] = React.useState(0);
  return (
    <div className="flex flex-col md:flex-row justify-between gap-7 md:gap-4 lg:gap-10 lg:my-10 lg:-mr-8 mr-0">
      <div className="md:w-2/3 relative">
        {(() => {
          return (
            <>
              <div className="overflow-hidden rounded-none md:rounded-3xl h-[415px] relative">
                {gallery.map((src, idx) => (
                  <Image
                    key={idx}
                    src={src?.image || "/placeholder.png"}
                    alt={`slide-${idx}`}
                    fill={false}
                    width={800}
                    height={415}
                    className={`absolute inset-0 w-full h-full object-cover rounded-3xl transition-opacity duration-500 ${
                      idx === active
                        ? "opacity-100"
                        : "opacity-0 pointer-events-none"
                    }`}
                  />
                ))}
              </div>

              {gallery.length > 1 && (
                <div className="absolute left-1/2 bottom-4 md:bottom-10 lg:bottom-4 transform -translate-x-1/2 flex gap-2 bg-black/30 rounded-full px-3 py-1">
                  {gallery.map((_, i) => (
                    <button
                      key={i}
                      onClick={() => setActive(i)}
                      className={`w-3 h-3 rounded-full transition-colors ${
                        i === active ? "bg-white" : "bg-white/50"
                      }`}
                    />
                  ))}
                </div>
              )}
            </>
          );
        })()}
      </div>
      <div className="md:w-1/3 border-yellow-500 border-[0.4px] pt-6 px-5 rounded-3xl">
        <div className="py-2 px-10 rounded-3xl bg-yellow-500 text-white typography-large-body-regular text-center mb-5">
          Package Highlights
        </div>
        {packageHighlights.map((item, index) => (
          <div key={index} className="flex mt-2">
            <p className="typography-mid-body-light text-grey-700 inline-flex items-center gap-1 line-clamp-4">
              <MapPin className="text-blue-600 font-light" /> {item?.title}
            </p>
          </div>
        ))}
        <Image
          src={highlight}
          alt="highlight"
          width={400}
          height={200}
          className="mt-1 md:h-40 md:w-40 lg:h-52 lg:w-52 mx-auto"
        />
      </div>
      <hr className="hidden md:block border-b border-grey-200 my-6" />
    </div>
  );
};

export default PackageHighlights;
